import { FC } from "react"

import { css } from "@emotion/react"
import { Link } from "@ncs/web-legos"
import { menuContainerStyle, navItemListStyle } from "./style"

export interface ShopBarNavSubmenuProps {
	items: {
		label: string | number
		to: string
	}[]
	columnCount?: number
}

export const ShopBarNavSubmenu: FC<ShopBarNavSubmenuProps> = ({ items, columnCount }) => {
	return (
		<div css={menuContainerStyle}>
			<ul
				className="navItemListStyle"
				css={[
					navItemListStyle,
					css`
						column-count: ${columnCount ?? 3};
					`,
				]}
			>
				{items.map((item) => (
					<li key={item.to}>
						<Link to={item.to}>{item.label}</Link>
					</li>
				))}
			</ul>
		</div>
	)
}
